module.exports = __webpack_public_path__ + "static/img/grey.397754e8.png";